import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, userSelector, clearState } from "../../User/UserSlice";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import AuthNavBar from "../nav/AuthNav";
import { useFlutterwave } from "react-flutterwave";
import { closePaymentModal } from "flutterwave-react-v3";
import Logo from "../../assets/logo.png";
import { useTranslation } from "react-i18next";

const OtherUpdateForm = () => {
  const { t, i18n } = useTranslation();
  const countryLabel = (country) => {
    try {
      return (
        new Intl.DisplayNames([i18n.language], { type: "region" }).of(
          country.code,
        ) || country.name
      );
    } catch (error) {
      return country.name;
    }
  };
  const dispatch = useDispatch();
  const { register, errors, handleSubmit } = useForm();
  const history = useHistory();

  const { isFetching, isSuccess, isError, errorMessage, successMessage } =
    useSelector(userSelector);

  const [email_mod, setEmail_mod] = useState(localStorage.getItem("email_mod"));

  const config = {
    public_key: "FLWPUBK_TEST-3b288a95bf15e944d7b6778c63693912-X",
    tx_ref: Date.now(),
    amount: 700,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: email_mod,
      phonenumber: "08148121206",
      name: "portal user",
    },
    customizations: {
      title: t("information_update"),
      description: t("payment_info_update_desc"),
      logo: Logo,
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  const onSubmit = (data) => {
    handleFlutterPayment({
      callback: (response) => {
        console.log(response);
        if (response.status == "successful") {
          closePaymentModal(); // this will close the modal programmatically
          dispatch(updateUser(data));
        }
      },
      onClose: () => {},
    });
  };

  useEffect(() => {
    return () => {
      dispatch(clearState());
    };
  }, []);

  const [statesfromapi, setStatesfromapi] = useState([]);
  const [getstatesid, setGetstateid] = useState([]);
  const [getstatesoriginid, setGetstateoriginid] = useState([]);
  const [lgasfromapi, setLgasfromapi] = useState([]);
  const [lgasoriginfromapi, setLgasoriginfromapi] = useState([]);

  const [successfulresponse, setSuccessfulresponse] = useState(false);

  useEffect(() => {
    let one = "http://197.234.41.86:806/states";

    const requestOne = axios.get(one);
    axios
      .all([requestOne])
      .then(
        axios.spread((...responses) => {
          const responseOne = responses[0];

          // use/access the results
          // console.log(responseOne);
          const resp = responseOne.data;

          setStatesfromapi(resp);
        }),
      )
      .catch((errors) => {
        // react on errors.
        console.error(errors);
      });
  }, []);

  useEffect(() => {
    axios
      .all([
        axios.get(
          "https://idms-preenrol.e-citizen.org/api/v1/states/" + getstatesid,
        ),
      ])
      .then(
        axios.spread((obj1) => {
          // Both requests are now complete
          const resp2 = obj1.data.LocalGOVs;
          setLgasfromapi(resp2);
        }),
      )
      .catch((error) => console.log(error));
  });

  useEffect(() => {
    if (isError) {
      toast.error(errorMessage);
      dispatch(clearState());
      history.push("/otherfield");
    }
    if (isSuccess) {
      toast.success(successMessage);
      dispatch(clearState());
      history.push("/report");
    }
  }, [isError, isSuccess]);

  const countries = [
    { name: "Afghanistan", code: "AF" },
    { name: "Åland Islands", code: "AX" },
    { name: "Albania", code: "AL" },
    { name: "Algeria", code: "DZ" },
    { name: "American Samoa", code: "AS" },
    { name: "AndorrA", code: "AD" },
    { name: "Angola", code: "AO" },
    { name: "Anguilla", code: "AI" },
    { name: "Antarctica", code: "AQ" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Argentina", code: "AR" },
    { name: "Armenia", code: "AM" },
    { name: "Aruba", code: "AW" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bahamas", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bermuda", code: "BM" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivia", code: "BO" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Botswana", code: "BW" },
    { name: "Bouvet Island", code: "BV" },
    { name: "Brazil", code: "BR" },
    { name: "British Indian Ocean Territory", code: "IO" },
    { name: "Brunei Darussalam", code: "BN" },
    { name: "Bulgaria", code: "BG" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cambodia", code: "KH" },
    { name: "Cameroon", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Cape Verde", code: "CV" },
    { name: "Cayman Islands", code: "KY" },
    { name: "Central African Republic", code: "CF" },
    { name: "Chad", code: "TD" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Christmas Island", code: "CX" },
    { name: "Cocos (Keeling) Islands", code: "CC" },
    { name: "Colombia", code: "CO" },
    { name: "Comoros", code: "KM" },
    { name: "Congo", code: "CG" },
    { name: "Congo, The Democratic Republic of the", code: "CD" },
    { name: "Cook Islands", code: "CK" },
    { name: "Costa Rica", code: "CR" },
    { name: 'Cote D"Ivoire', code: "CI" },
    { name: "Croatia", code: "HR" },
    { name: "Cuba", code: "CU" },
    { name: "Cyprus", code: "CY" },
    { name: "Czech Republic", code: "CZ" },
    { name: "Denmark", code: "DK" },
    { name: "Djibouti", code: "DJ" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Equatorial Guinea", code: "GQ" },
    { name: "Eritrea", code: "ER" },
    { name: "Estonia", code: "EE" },
    { name: "Ethiopia", code: "ET" },
    { name: "Falkland Islands (Malvinas)", code: "FK" },
    { name: "Faroe Islands", code: "FO" },
    { name: "Fiji", code: "FJ" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "French Guiana", code: "GF" },
    { name: "French Polynesia", code: "PF" },
    { name: "French Southern Territories", code: "TF" },
    { name: "Gabon", code: "GA" },
    { name: "Gambia", code: "GM" },
    { name: "Georgia", code: "GE" },
    { name: "Germany", code: "DE" },
    { name: "Ghana", code: "GH" },
    { name: "Gibraltar", code: "GI" },
    { name: "Greece", code: "GR" },
    { name: "Greenland", code: "GL" },
    { name: "Grenada", code: "GD" },
    { name: "Guadeloupe", code: "GP" },
    { name: "Guam", code: "GU" },
    { name: "Guatemala", code: "GT" },
    { name: "Guernsey", code: "GG" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Heard Island and Mcdonald Islands", code: "HM" },
    { name: "Holy See (Vatican City State)", code: "VA" },
    { name: "Honduras", code: "HN" },
    { name: "Hong Kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Indonesia", code: "ID" },
    { name: "Iran, Islamic Republic Of", code: "IR" },
    { name: "Iraq", code: "IQ" },
    { name: "Ireland", code: "IE" },
    { name: "Isle of Man", code: "IM" },
    { name: "Israel", code: "IL" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jersey", code: "JE" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kiribati", code: "KI" },
    { name: 'Korea, Democratic People"S Republic of', code: "KP" },
    { name: "Korea, Republic of", code: "KR" },
    { name: "Kuwait", code: "KW" },
    { name: "Kyrgyzstan", code: "KG" },
    { name: 'Lao People"S Democratic Republic', code: "LA" },
    { name: "Latvia", code: "LV" },
    { name: "Lebanon", code: "LB" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libyan Arab Jamahiriya", code: "LY" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Macao", code: "MO" },
    { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Marshall Islands", code: "MH" },
    { name: "Martinique", code: "MQ" },
    { name: "Mauritania", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mayotte", code: "YT" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia, Federated States of", code: "FM" },
    { name: "Moldova, Republic of", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montserrat", code: "MS" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "Netherlands", code: "NL" },
    { name: "Netherlands Antilles", code: "AN" },
    { name: "New Caledonia", code: "NC" },
    { name: "New Zealand", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "Niue", code: "NU" },
    { name: "Norfolk Island", code: "NF" },
    { name: "Northern Mariana Islands", code: "MP" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Pakistan", code: "PK" },
    { name: "Palau", code: "PW" },
    { name: "Palestinian Territory, Occupied", code: "PS" },
    { name: "Panama", code: "PA" },
    { name: "Papua New Guinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Pitcairn", code: "PN" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Puerto Rico", code: "PR" },
    { name: "Qatar", code: "QA" },
    { name: "Reunion", code: "RE" },
    { name: "Romania", code: "RO" },
    { name: "Russian Federation", code: "RU" },
    { name: "RWANDA", code: "RW" },
    { name: "Saint Helena", code: "SH" },
    { name: "Saint Kitts and Nevis", code: "KN" },
    { name: "Saint Lucia", code: "LC" },
    { name: "Saint Pierre and Miquelon", code: "PM" },
    { name: "Saint Vincent and the Grenadines", code: "VC" },
    { name: "Samoa", code: "WS" },
    { name: "San Marino", code: "SM" },
    { name: "Sao Tome and Principe", code: "ST" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Senegal", code: "SN" },
    { name: "Serbia and Montenegro", code: "CS" },
    { name: "Seychelles", code: "SC" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapore", code: "SG" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "Solomon Islands", code: "SB" },
    { name: "Somalia", code: "SO" },
    { name: "South Africa", code: "ZA" },
    { name: "South Georgia and the South Sandwich Islands", code: "GS" },
    { name: "Spain", code: "ES" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Sudan", code: "SD" },
    { name: "Suri'name", code: "SR" },
    { name: "Svalbard and Jan Mayen", code: "SJ" },
    { name: "Swaziland", code: "SZ" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Syrian Arab Republic", code: "SY" },
    { name: "Taiwan, Province of China", code: "TW" },
    { name: "Tajikistan", code: "TJ" },
    { name: "Tanzania, United Republic of", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tokelau", code: "TK" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Tunisia", code: "TN" },
    { name: "Turkey", code: "TR" },
    { name: "Turkmenistan", code: "TM" },
    { name: "Turks and Caicos Islands", code: "TC" },
    { name: "Tuvalu", code: "TV" },
    { name: "Uganda", code: "UG" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    { name: "United Kingdom", code: "GB" },
    { name: "United States", code: "US" },
    { name: "United States Minor Outlying Islands", code: "UM" },
    { name: "Uruguay", code: "UY" },
    { name: "Uzbekistan", code: "UZ" },
    { name: "Vanuatu", code: "VU" },
    { name: "Venezuela", code: "VE" },
    { name: "Viet Nam", code: "VN" },
    { name: "Virgin Islands, British", code: "VG" },
    { name: "Virgin Islands, U.S.", code: "VI" },
    { name: "Wallis and Futuna", code: "WF" },
    { name: "Western Sahara", code: "EH" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" },
  ];

  let [caption, setCaption] = useState(t("house_rent"));
  const [first_name_mod, setFirst_name_mod] = useState(
    localStorage.getItem("first_name_mod"),
  );
  const [specialty_mod, setSpecialty_mod] = useState(
    localStorage.getItem("specialty_mod"),
  );
  const [state_of_origin_mod, setState_of_origin_mod] = useState(
    localStorage.getItem("state_of_origin_mod"),
  );
  const [business_address_mod, setbusiness_address_mod] = useState(
    localStorage.getItem("business_address_mod"),
  );
  const [nok_phone_mod, setNok_phone_mod] = useState(
    localStorage.getItem("nok_phone_mod"),
  );
  const [rent_cost_mod, setRent_cost_mod] = useState(
    localStorage.getItem("rent_cost_mod"),
  );
  const [nok_relationship_mod, setNok_relationship_mod] = useState(
    localStorage.getItem("nok_relationship_mod"),
  );
  const [health_insurance_mod, setHealth_insurance_mod] = useState(
    localStorage.getItem("health_insurance_mod"),
  );
  const [state_residence_mod, setState_residence_mod] = useState(
    localStorage.getItem("state_residence_mod"),
  );
  const [has_own_house_mod, setHas_own_house_mod] = useState(
    localStorage.getItem("has_own_house_mod"),
  );
  const [house_cost_mod, setHouse_cost_mod] = useState(
    localStorage.getItem("house_cost_mod"),
  );
  const [house_condition_mod, setHouse_condition_mod] = useState(
    localStorage.getItem("house_condition_mod"),
  );
  const [transport_means_mod, setTransport_means_mod] = useState(
    localStorage.getItem("transport_means_mod"),
  );
  const [nok_address_mod, setNok_address_mod] = useState(
    localStorage.getItem("nok_address_mod"),
  );
  const [trackId_mod, setTrackId_mod] = useState(
    localStorage.getItem("trackId_mod"),
  );
  const [time_to_office_mod, setTime_to_office_mod] = useState(
    localStorage.getItem("time_to_office_mod"),
  );
  const [phone_number_mod, setPhone_number_mod] = useState(
    localStorage.getItem("phone_number_mod"),
  );
  const [education_level_mod, setEducation_level_mod] = useState(
    localStorage.getItem("education_level_mod"),
  );
  const [spoken_language_mod, setSpoken_language_mod] = useState(
    localStorage.getItem("spoken_language_mod"),
  );
  const [disability_type_mod, setDisability_type_mod] = useState(
    localStorage.getItem("disability_type_mod"),
  );
  const [date_of_birth_mod, setDate_of_birth_mod] = useState(
    localStorage.getItem("date_of_birth_mod"),
  );
  const [industry_mod, setIndustry_mod] = useState(
    localStorage.getItem("industry_mod"),
  );
  const [has_own_business_mod, setHas_own_business_mod] = useState(
    localStorage.getItem("has_own_business_mod"),
  );
  const [home_address_mod, setHome_address_mod] = useState(
    localStorage.getItem("home_address_mod"),
  );
  const [employment_status_mod, setEmployment_status_mod] = useState(
    localStorage.getItem("employment_status_mod"),
  );

  const [has_computer_mod, setHas_computer_mod] = useState(
    localStorage.getItem("has_computer_mod"),
  );
  const [daily_expenses_mod, setDaily_expenses_mod] = useState(
    localStorage.getItem("daily_expenses_mod"),
  );
  const [number_of_businesses_mod, setNumber_of_businesses_mod] = useState(
    localStorage.getItem("number_of_businesses_mod"),
  );
  const [sex_mod, setSex_mod] = useState(localStorage.getItem("sex_mod"));
  const [last_name_mod, setLast_name_mod] = useState(
    localStorage.getItem("last_name_mod"),
  );
  const [nok_first_name_mod, setNok_first_name_mod] = useState(
    localStorage.getItem("nok_first_name_mod"),
  );
  const [marital_status_mod, setMarital_status_mod] = useState(
    localStorage.getItem("marital_status_mod"),
  );
  const [nok_last_name_mod, setNok_last_name_mod] = useState(
    localStorage.getItem("nok_last_name_mod"),
  );
  const [bVN_mod, setBVN_mod] = useState(localStorage.getItem("BVN_mod"));
  const [religion_mod, setReligion_mod] = useState(
    localStorage.getItem("religion"),
  );

  return (
    <Fragment>
      <div className="container">
        <h4 className="text-secondary">{t("update_record")}</h4>

        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
          <div className="card text-dark bg-light">
            <div className="card-body">
              <form
                className="space-y-6"
                onSubmit={handleSubmit(onSubmit)}
                method="POST"
              >
                <h5
                  className="card-title"
                  style={{ backgroundColor: "rgba(30, 78, 255, 0.24)" }}
                >{t("bio_data")}</h5>
                <div className="row">
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputFirstName" className="form-label">{t("first_name")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        id="firstName"
                        name="firstName"
                        type="text"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        required
                        value={first_name_mod}
                        onChange={(e) => {
                          setFirst_name_mod(e.target.value);
                        }}
                        autocomplete="FirstName"
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputLastName" className="form-label">{t("last_name")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        id="lastName"
                        type="text"
                        name="lastName"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        required
                        value={last_name_mod}
                        onChange={(e) => {
                          setLast_name_mod(e.target.value);
                        }}
                        autocomplete="lastName"
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputOtherName" className="form-label">{t("other_name")}</label>
                      <input
                        className="form-control"
                        id="otherName"
                        ref={register({ required: false })}
                        name="othername"
                        style={{ textTransform: "uppercase" }}
                        type="text"
                        autocomplete="otherName"
                      />
                    </div>
                  </div>
                  {/* <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("dob")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        aria-describedby="DOBHelp"
                        ref={register({ required: true })}
                        id="dob"
                        name="dob"
                        value={date_of_birth_mod}
                        onChange={(e) => {
                          setDate_of_birth_mod(e.target.value)
                        }}
                      />
                    </div>
                  </div> */}
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("gender")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sex"
                        name="sex"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setSex_mod(e.target.value);
                        }}
                        required
                      >
                        <option>{sex_mod}</option>
                        <option value="male">{t("male")}</option>
                        <option value="female">{t("female")}</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">
                        {t("email_address")}
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={email_mod}
                        onChange={(e) => {
                          setEmail_mod(e.target.value);
                        }}
                        ref={register({ required: false })}
                        id="exampleInputDOB"
                        aria-describedby="DOBHelp"
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-6">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">{t("house_address")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        className="form-control"
                        aria-label="With textarea"
                        name="houseAddress"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        required
                        value={home_address_mod}
                        onChange={(e) => {
                          setHome_address_mod(e.target.value);
                        }}
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">{t("nin")}</label>

                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputDOB"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: false })}
                        aria-describedby="DOBHelp"
                        name="nin"
                      />
                      <div id="emailHelp" className="form-text">{t("nin_privacy")}</div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">{t("tracking_id")}</label>

                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputDOB"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: false })}
                        aria-describedby="DOBHelp"
                        name="trackId"
                        value={trackId_mod}
                        onChange={(e) => {
                          setTrackId_mod(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">{t("bvn")}</label>

                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputDOB"
                        aria-describedby="DOBHelp"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: false })}
                        name="bvn"
                        value={bVN_mod}
                        onChange={(e) => {
                          setBVN_mod(e.target.value);
                        }}
                      />
                      <div id="emailHelp" className="form-text">{t("bvn_privacy")}</div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">{t("phone_number")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        max="11"
                        className="form-control"
                        id="exampleInputDOB"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        name="phoneNumber"
                        aria-describedby="DOBHelp"
                        value={phone_number_mod}
                        onChange={(e) => {
                          setPhone_number_mod(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <h5 style={{ backgroundColor: "rgba(30, 78, 255, 0.24)" }}>{t("additional_information")}</h5>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {t("level_of_education")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="educationLevel"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setEducation_level_mod(e.target.value);
                        }}
                      >
                        <option selected>{education_level_mod}</option>
                        <option value="Primary">{t("primary")}</option>
                        <option value="Secondary">{t("secondary")}</option>
                        <option value="Tertiary">{t("tertiary")}</option>
                        <option value="Others">{t("others")}</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {t("disability_if_any")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="disabilityType"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        value={disability_type_mod}
                        onChange={(e) => {
                          setDisability_type_mod(e.target.value);
                        }}
                      >
                        <option selected>{disability_type_mod}</option>
                        <option value="none">{t("none")}</option>
                        <option value="albinism">{t("albinism")}</option>
                        <option value="blindness">{t("blindness")}</option>
                        <option value="deafness">{t("deafness")}</option>
                        <option value="little stature">{t("little_stature")}</option>
                        <option value="Cognitive">{t("cognitive_disabilities")}</option>
                        <option value="others">{t("others")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("health_insurance")}</label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="withHealthInsurance"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setHealth_insurance_mod(e.target.value);
                        }}
                      >
                        <option selected>{health_insurance_mod}</option>
                        <option value="0">{t("yes")}</option>
                        <option value="1">{t("no")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {t("employment_status")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="specialtyId"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setEmployment_status_mod(e.target.value);
                        }}
                      >
                        <option selected>{employment_status_mod}</option>
                        <option value="Unemployed">{t("unemployed")}</option>
                        <option value="Employed">{t("employed")}</option>
                        <option value="Self Employed">{t("self_employed")}</option>
                        <option value="Student">{t("student")}</option>
                        <option value="Retired">{t("retired")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("marital_status")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="maritalStatus"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setMarital_status_mod(e.target.value);
                        }}
                      >
                        <option selected>{marital_status_mod}</option>
                        <option value="Single">{t("single")}</option>
                        <option value="Married">{t("married")}</option>
                        <option value="Widowed">{t("widowed")}</option>
                        <option value="Divorced">{t("divorced")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("religion")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="religion"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setReligion_mod(e.target.value);
                        }}
                      >
                        <option selected>{religion_mod}</option>
                        <option value="Christianity">{t("christianity")}</option>
                        <option value="Islam">{t("islam")}</option>
                        <option value="Traditional">{t("traditional")}</option>
                        <option value="Others">{t("others")}</option>
                      </select>
                    </div>
                  </div>

                  <h5 style={{ backgroundColor: "rgba(30, 78, 255, 0.24)" }}>{t("residence_where_live")}</h5>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {t("country_of_residence")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="country"
                        style={{ textTransform: "uppercase" }}
                      >
                        <option selected>{t("nigeria")}</option>
                        {countries
                          .sort((a, b) => (a.timeM > b.timeM ? 1 : -1))
                          .map((country, index) => {
                            return (
                              <option selected value={country.name}>
                                {countryLabel(country)}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {t("state_of_residence")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        style={{ textTransform: "uppercase" }}
                        aria-label="Default select example"
                        name="residenceState"
                        onChange={(event) => {
                          setGetstateid(event.target.value);
                          console.log(getstatesid);
                        }}
                      >
                        <option>{t("open_select_menu")}</option>
                        {statesfromapi &&
                          statesfromapi.map((statefromapi, index) => {
                            return (
                              <option value={statefromapi.staetId}>
                                {statefromapi.state}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {t("lga_city_residence")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        style={{ textTransform: "uppercase" }}
                        className="form-select"
                        aria-label="Default select example"
                        name="residenceLGA"
                      >
                        <option selected>{t("open_select_menu")}</option>
                        {lgasfromapi &&
                          lgasfromapi.map((lgafromapi, index) => {
                            return (
                              <option selected value={lgafromapi.is}>
                                {lgafromapi.lgName}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>

                  <h5 style={{ backgroundColor: "rgba(30, 78, 255, 0.24)" }}>{t("origin_information")}</h5>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {t("country_of_origin")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        disabled
                        style={{ textTransform: "uppercase" }}
                        className="form-select"
                        aria-label="Default select example"
                        name="country"
                      >
                        <option selected>{t("nigeria")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("state_of_origin")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        style={{ textTransform: "uppercase" }}
                        className="form-select"
                        aria-label="Default select example"
                        name="originState"
                        onChange={(event) => {
                          setGetstateoriginid(event.target.value);
                          console.log(getstatesoriginid);
                        }}
                      >
                        <option>{t("open_select_menu")}</option>
                        {statesfromapi &&
                          statesfromapi.map((statefromapi, index) => {
                            return (
                              <option value={statefromapi.staetId}>
                                {statefromapi.state}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {t("lga_city_origin")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        style={{ textTransform: "uppercase" }}
                        className="form-select"
                        aria-label="Default select example"
                        name="lgId"
                      >
                        <option selected>{t("open_select_menu")}</option>
                        {lgasoriginfromapi &&
                          lgasoriginfromapi.map((lgaoriginfromapi, index) => {
                            return (
                              <option selected value={lgaoriginfromapi.id}>
                                {lgaoriginfromapi.lgName}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>

                  <h5 style={{ backgroundColor: "rgba(30, 78, 255, 0.24)" }}>{t("next_of_kin_info")}</h5>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">
                        {t("next_of_kin_first_name")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        style={{ textTransform: "uppercase" }}
                        className="form-control"
                        id="exampleInputDOB"
                        aria-describedby="DOBHelp"
                        name="nokFirstName"
                        ref={register({ required: true })}
                        value={nok_first_name_mod}
                        onChange={(e) => {
                          setNok_first_name_mod(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">
                        {t("next_of_kin_last_name")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        style={{ textTransform: "uppercase" }}
                        className="form-control"
                        id="exampleInputDOB"
                        aria-describedby="DOBHelp"
                        name="nokLastName"
                        ref={register({ required: true })}
                        value={nok_last_name_mod}
                        onChange={(e) => {
                          setLast_name_mod(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("next_of_kin_relationship")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        style={{ textTransform: "uppercase" }}
                        aria-label="Default select example"
                        name="nokRelationship"
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setNok_relationship_mod(e.target.value);
                        }}
                      >
                        <option selected>{nok_relationship_mod}</option>
                        <option value="Parent">{t("parent")}</option>
                        <option value="Child">{t("child")}</option>
                        <option value="Spouse">{t("spouse")}</option>
                        <option value="Others">{t("others")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">{t("next_of_kin_phone")}</label>
                      <input
                        type="number"
                        className="form-control"
                        style={{ textTransform: "uppercase" }}
                        id="exampleInputDOB"
                        aria-describedby="DOBHelp"
                        name="nokPhone"
                        ref={register({ required: true })}
                        value={nok_phone_mod}
                        onChange={(e) => {
                          setNok_phone_mod(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputEmail" className="form-label">
                        {t("next_of_kin_house_address")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        className="form-control"
                        style={{ textTransform: "uppercase" }}
                        aria-label="With textarea"
                        name="nokAddress"
                        ref={register({ required: false })}
                        value={nok_address_mod}
                        onChange={(e) => {
                          setNok_address_mod(e.target.value);
                        }}
                      ></textarea>
                    </div>
                  </div>

                  <h5 style={{ backgroundColor: "rgba(30, 78, 255, 0.24)" }}>{t("housing_info")}</h5>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("own_house")}</label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="ownHouse"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(event) => {
                          if (event.target.value === "0") {
                            setCaption(t("house_rent_cost"));
                          } else {
                            setCaption("Property Value");
                          }
                        }}
                      >
                        <option selected>{t("open_select_menu")}</option>
                        <option value="0">{t("no")}</option>
                        <option value="1">{t("yes")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">
                        {caption}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="exampleInputDOB"
                        style={{ textTransform: "uppercase" }}
                        aria-describedby="DOBHelp"
                        name="rentCost"
                        ref={register({ required: false })}
                      />
                      <div id="emailHelp" className="form-text">{t("enter_amount_figures")}</div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("spoken_language")}</label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="spokenLanguage"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setSpoken_language_mod(e.target.value);
                        }}
                      >
                        <option selected>{spoken_language_mod}</option>
                        <option value="English">{t("language_english")}</option>
                        <option value="Hausa">{t("hausa")}</option>
                        <option value="Igbo">{t("igbo")}</option>
                        <option value="Yoruba">{t("yoruba")}</option>
                        <option value="Others">{t("others")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("own_computer")}</label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="hasComputer"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setHas_computer_mod(e.target.value);
                        }}
                      >
                        <option selected>{t("open_select_menu")}</option>
                        <option value="1">{t("yes")}</option>
                        <option value="0">{t("no")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("means_transportation")}</label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="transportMeans"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setTransport_means_mod(e.target.value);
                        }}
                      >
                        <option selected>{transport_means_mod}</option>
                        <option value="Private Transport">{t("private_transport")}</option>
                        <option value="Public Transport">{t("public_transport")}</option>
                        <option value="By Foot">{t("by_foot")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("daily_expenditure")}</label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="dailyExpenses"
                        style={{ textTransform: "uppercase" }}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setDaily_expenses_mod(e.target.value);
                        }}
                      >
                        <option selected>{t("open_select_menu")}</option>
                        <option value="Below 1000">{t("below_1000")}</option>
                        <option value="1000">1000</option>
                        <option value="Above 1000">{t("above_1000")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("own_business")}</label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="ownBusiness"
                        ref={register({ required: true })}
                        value={has_own_business_mod}
                        onChange={(e) => {
                          setHas_own_business_mod(e.target.value);
                        }}
                      >
                        <option selected>{t("open_select_menu")}</option>
                        <option value="Yes">{t("yes")}</option>
                        <option value="No">{t("no")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-5 col-lg-3">
                    <div className="mb-3 input-group-sm">
                      <label for="exampleInputDOB" className="form-label">{t("number_businesses")}</label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="noOfBusiness"
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setNumber_of_businesses_mod(e.target.value);
                        }}
                      >
                        <option selected>{number_of_businesses_mod}</option>
                        <option value="None">{t("none")}</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="Above 2">{t("above_2")}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  {isFetching ? (
                    <Fragment>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>

                      <p>{t("updating_user_details")}</p>
                    </Fragment>
                  ) : (
                    <span>{t("update_btn")}</span>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OtherUpdateForm;
